import { SimpleReminderTable } from "@/routes/app/my/reminders/-components/SimpleReminderTable"
import { DefaultModal } from "@components/default-modal"
import { useGetCurrentObjectTitle } from "@components/use-get-current-object-title"

export interface FilteredRemindersModalProps {
  opened: boolean
  onClose: () => void
}

export function FilteredRemindersModal({
  opened,
  onClose,
}: FilteredRemindersModalProps) {
  return (
    <DefaultModal
      opened={opened}
      onClose={onClose}
      centered
      size={"60%"}
      title={useGetCurrentObjectTitle()}
    >
      <SimpleReminderTable />
    </DefaultModal>
  )
}
